<template>
    <div class="imgUpload">
        <div>
            <div id="selectfiles"></div>
            <input
                    class="mu-button-wrapper"
                    @change="select_file"
                    :accept="accept"
                    type="file"
                    style="position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    width: 100%;
                    height: 100%;
                    overflow: hidden;
                    cursor: pointer;
                    opacity:0;
                    z-index: 999"
            />
            <slot/>
            <div class="signup_up">
                <div v-if="ossurl"  style="position: relative;">
                    <van-image fit="contain" class="video"
                               :src="ossurl|videoposter"/>
                </div>
                <div class="video_img"  v-else >
                    <van-icon  name="video" size="1.05rem" color="#FFFFFF"/>
                </div>
                <div class="signup_notice">
                    <template v-if="!ossurl">
                        点击上传视频（不大于300MB）
                    </template>
                    <div id="console" style="color: red;font-weight: bold;"></div>
                </div>
            </div>
            <div v-if="ossurl" style="text-align: center;margin-top:.2rem;">上传成功!<span style="color:cornflowerblue;">重新上传</span></div>
        </div>
        <Overlay :show="loading" z-index="100">
            <div style="display:flex; align-items: center;
  justify-content: center;
  height: 100%;">
                <van-circle stroke-width="50" :value="percentage" :text="percentage+'%'" fill="#FFFFFF90" :color="{'0%':'#F6C87F','100%':'#FF7B4E'}" />
            </div>
        </Overlay>

    </div>
</template>

<script>

    var accessid = ''
    var accesskey = ''
    var host = ''
    var policyBase64 = ''
    var signature = ''
    var callbackbody = ''
    var filename = ''
    var key = ''
    var expire = 0
    var g_object_name = ''
    var g_object_name_type = ''
    var now = Date.parse(new Date()) / 1000;
    var timestamp = Date.parse(new Date()) / 1000;

    function check_object_radio() {
        g_object_name_type = 'random_name';
    }

    async function get_signature() {
        // 可以判断当前expire是否超过了当前时间， 如果超过了当前时间， 就重新取一下，3s 作为缓冲。
        now = timestamp = Date.parse(new Date()) / 1000;
        if (expire < now + 3) {
            let res = await api.common.ossSignature();
            let obj = res.data;
            host = obj["host"];
            policyBase64 = obj["policy"];
            accessid = obj["accessid"];
            signature = obj["signature"];
            expire = parseInt(obj["expire"]);
            callbackbody = obj["callback"];
            key = obj["dir"];
            return true;
        }
        return false;
    }

    function random_string(len) {
        len = len || 32;
        var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
        var maxPos = chars.length;
        var pwd = '';
        for (var i = 0; i < len; i++) {
            pwd += chars.charAt(Math.floor(Math.random() * maxPos));
        }
        return pwd;
    }

    function get_suffix(filename) {
        var pos = filename.lastIndexOf('.')
        var suffix = ''
        if (pos != -1) {
            suffix = filename.substring(pos)
        }
        return suffix;
    }


    function calculate_object_name(filename) {
        if (g_object_name_type == 'local_name') {
            g_object_name += "${filename}"
        } else if (g_object_name_type == 'random_name') {
            var suffix = get_suffix(filename)
            g_object_name = key + random_string(10) + suffix
        }
        return ''
    }

    function get_uploaded_object_name(filename) {
        if (g_object_name_type == 'local_name') {
            tmp_name = g_object_name
            tmp_name = tmp_name.replace("${filename}", filename);
            return tmp_name
        } else if (g_object_name_type == 'random_name') {
            return g_object_name
        }
    }

    async function set_upload_param(up, filename, ret) {
        if (ret == false) {
            ret = await get_signature()
        }
        g_object_name = key;
        if (filename != '') {
            var suffix = get_suffix(filename)
            calculate_object_name(filename)
        }
        let new_multipart_params = {
            'key': g_object_name,
            'policy': policyBase64,
            'OSSAccessKeyId': accessid,
            'success_action_status': '200', //让服务端返回200,不然，默认会返回204
            'callback': callbackbody,
            'signature': signature,
        };

        up.setOption({
            'url': host,
            'multipart_params': new_multipart_params
        });

        up.start();
    }

    import plupload from "plupload";
    import {Button, Icon, Loading, Overlay, Image,Circle} from 'vant';
    import api from '@/api'

    export default {
        components: {
            Button,
            Icon,
            Loading,
            Overlay,
            VanImage: Image,
            VanCircle:Circle
        },
        model: {
            prop: "msg",
            event: "ee"
        },
        props: {
            value: {
                default: ''
            },
            accept: {
                default: 'video/*'
            },
            keyname:{
                default:''
            }
        },
        data() {
            return {
                url: this.msg || "",
                uploader: null,
                ossurl: this.value,
                percent: 0,
                loading: false,
                percentage:0
            };
        },
        created() {
        },
        mounted() {
            this.ossurl = this.value;
            this.initPlUploader();
        },
        methods: {
            select() {
                this.initPlUploader();
            },
            select_file(e) {
                let file = e.target.files[0];
                this.uploader.addFile(file);
            },
            /**
             * 初始化上传插件
             */
            initPlUploader() {
                let self = this;
                this.uploader = new plupload.Uploader({
                    runtimes: "html5,flash,silverlight,html4",
                    browse_button: "selectfiles",
                    url: "https://oss.aliyuncs.com",
                    filters: {
                        max_file_size: "300mb", //最大只能上传10mb的文件
                        prevent_duplicates: true //不允许选取重复文件
                    },
                    init: {
                        UploadProgress:function(uploader,file){
                            self.percentage =   file.percent;
                        },
                        FilesAdded: function (up, file) {
                            document
                                .getElementById("console").innerText = '';
                            file = file[0]
                            var typearr = [".mov", ".mp4", ".MOV", ".MP4"];
                            //微信浏览器 accept限制格式有误
                            var index1 = file.name.lastIndexOf(".");
                            var index2 = file.name.length;
                            var type = file.name.substring(index1, index2);
                            if (typearr.indexOf(type) === -1) {
                                document
                                    .getElementById("console")
                                    .appendChild(
                                        document.createTextNode(
                                            "\n文件格式有误,请上传视频文件"
                                        )
                                    );
                                return;
                            }
                            set_upload_param(up, "", false);
                        },
                        BeforeUpload: function (up, file) {
                            check_object_radio();
                            self.loading = true;
                            set_upload_param(up, file.name, true);
                        },
                        FileUploaded: function (up, file, info) {
                            //文件渲染时间
                            setTimeout(()=>{
                                self.loading = false;
                            },1e3)
                            if (info.status === 200) {
                                self.ossurl =
                                    host +
                                    "/" +
                                    get_uploaded_object_name(file.name);
                                // 修改 URL 而不添加新的历史记录
                                let path = window.localStorage.getItem("getPath");
                                if(path) {
                                    history.replaceState({}, '', path);
                                }
                                
                            } else if (+info.status === 203) {
                                console.log(
                                    "上传到OSS成功，但是oss访问用户设置的上传回调服务器失败，失败原因是:" +
                                    info.response
                                );
                            } else {
                                console.log(info.response);
                            }
                        },
                        Error: function (up, err) {
                            self.loading = false;
                            let msg = '';
                            if (+err.code === -600) {
                                msg = '选择的文件太大了';
                                document
                                    .getElementById("console")
                                    .appendChild(
                                        document.createTextNode(
                                            "\n选择的文件太大了,请上传300M以内的文件"
                                        )
                                    );
                            } else if (err.code == -601) {
                                msg = '文件类型有误';
                                console.log("请上传文件类型的文件");
                                document
                                    .getElementById("console")
                                    .appendChild(document.createTextNode("\n请上传文件类型的文件"));
                            } else if (err.code == -602) {
                                msg = '这个文件已经上传过一遍了';

                                // console.log(self.ossurl)
                                self.$emit("setUrl", self.ossurl);
                                document
                                    .getElementById("console")
                                    .appendChild(
                                        document.createTextNode("\n这个文件已经上传过一遍了")
                                    );
                            } else {
                                console.log(err);

                                document
                                    .getElementById("console")
                                    .appendChild(
                                        document.createTextNode("\nError xml:" + err.response)
                                    );
                            }
                        }
                    }
                });
                this.uploader.init();
            }
        },
        watch: {
            value(newVal) {
                this.ossurl = newVal;
            },
            ossurl(newVal) {
                this.$emit("setUrl", newVal,this.keyname);
            }
        }
    };
</script>

<style lang="less" scoped>
    .imgUpload {
        height: 100%;
        width: 100%;
        position: relative;
    }

    .signup_up {
        height: 2.77rem;
        border-radius: 0.16rem;
        background: #F3F3F3;
        margin: auto;
        display: flex;
        align-items: center;
        justify-content:space-around;
        flex-direction: column;
        overflow: hidden;

        .signup_notice {
            box-sizing: border-box;
            font-size: 12px;
            color: #999999;
        }

        .video_img {
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
</style>

